import { create } from 'zustand';
import type { PositionOverride } from '../data/overridesRuntime';
import { fetchAndApplyOverrides } from '../data/refreshOverrides';

/**
 * positionOverridesDraft — guarda directamente la posición corregida de un
 * regulador (Modo Edición). Guardado real desde 2026-09-10 (antes: export a
 * un snippet de texto que nunca llegaba a pegarse — ver ROADMAP.md). El
 * estado ya no vive aquí: tras cada escritura se vuelve a pedir
 * `GET /api/overrides` completo (fuente de verdad única) y se aplica sobre
 * `overridesRuntime.ts`, que es lo que el resto de la app lee.
 */
export type { PositionOverride as PositionOverrideDraft } from '../data/overridesRuntime';

interface DraftState {
  saving: boolean;
  stage: (d: PositionOverride) => Promise<boolean>;
  remove: (logicalId: number) => Promise<boolean>;
}

export const usePositionOverridesDraft = create<DraftState>((set) => ({
  saving: false,
  stage: async (d) => {
    set({ saving: true });
    try {
      const res = await fetch(`/api/overrides/regulator_position/${d.logicalId}`, {
        method: 'PUT',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(d),
      });
      if (!res.ok) return false;
      await fetchAndApplyOverrides();
      return true;
    } catch {
      return false;
    } finally {
      set({ saving: false });
    }
  },
  remove: async (logicalId) => {
    set({ saving: true });
    try {
      const res = await fetch(`/api/overrides/regulator_position/${logicalId}`, {
        method: 'DELETE',
        credentials: 'include',
      });
      if (!res.ok && res.status !== 404) return false;
      await fetchAndApplyOverrides();
      return true;
    } catch {
      return false;
    } finally {
      set({ saving: false });
    }
  },
}));
